export default __webpack_public_path__ + "static/media/log.802a15df.svg";